import type * as React from 'react';

import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

import { useRefinerFormURL } from '../../../Components';
import { useHomeContext } from '../HomeContext';

/**
 * Footer for the home screen.
 */
export const HomeFooter = (): React.ReactElement => {
    const {
        organization: { id: organizationId },
    } = useHomeContext();
    const changelogUrl = new URL('https://gitbook.com/docs/changelog');
    const feedbackUrlWithUserData = useRefinerFormURL({
        uri: 'https://survey.refiner.io/e61q1m-dz5gpn',
        organizationId,
        source: 'home-dashboard',
    });

    return (
        <div className="flex w-full items-center justify-between border-base border-t pt-6 pb-10">
            <Button
                label="What's new"
                leadingIcon={Icon.EmojiHeart}
                kind="secondary"
                href={changelogUrl.toString()}
                target="_blank"
            />

            <Button
                kind="secondary"
                label="Leave us feedback"
                href={feedbackUrlWithUserData}
                target="_blank"
            />
        </div>
    );
};
